import { useCallback } from 'react'
import { useStore } from '../providers/store'
import {
	formatGroupCookieName,
	isMatchStoreByCodeInPath,
	isMatchStoreByDevUrl,
	isMatchStoreByNone,
	isMatchStoreByUrl,
} from '../utils'

const PATH_ROOT = '/'

export const useCookiesByGroupActions = ({ setCookie, removeCookie }) => {
	const { groupId: currentGroupId, hostname: currentHostname } = useStore()

	const saveOnCurrentGroup = useCallback(
		(name, value, options) => {
			setCookie(formatGroupCookieName(currentGroupId, name), value, {
				path: PATH_ROOT,
				currentHostname,
				...options,
			})
		},
		[currentGroupId, currentHostname, setCookie]
	)

	const removeFromCurrentGroup = useCallback(
		(name, options) => {
			removeCookie(formatGroupCookieName(currentGroupId, name), {
				path: PATH_ROOT,
				currentHostname,
				...options,
			})
		},
		[removeCookie, currentGroupId, currentHostname]
	)

	const setCookiesByGroup = useCallback(
		(name, value, options) => {
			if (isMatchStoreByUrl() || isMatchStoreByDevUrl() || isMatchStoreByCodeInPath()) {
				saveOnCurrentGroup(name, value, options)
			} else if (isMatchStoreByNone()) {
				setCookie(name, value, options)
			}
		},
		[saveOnCurrentGroup, setCookie]
	)

	const removeCookiesByGroup = useCallback(
		(name, options) => {
			if (isMatchStoreByUrl() || isMatchStoreByDevUrl() || isMatchStoreByCodeInPath()) {
				removeFromCurrentGroup(name, options)
			} else if (isMatchStoreByNone()) {
				removeCookie(name, options)
			}
		},
		[removeFromCurrentGroup, removeCookie]
	)

	return { setCookiesByGroup, removeCookiesByGroup }
}
